import axios from './axios'

const createQueryString = (params, path) => {
  const queryString = Object.entries(params)
    .map(([key, value]) =>
      value ? `${encodeURIComponent(key)}=${encodeURIComponent(value)}` : null
    )
    .filter((item) => item)
    .join('&')
  return path + '?' + queryString
}

const getAppointmentsList = async (params) =>
  axios.get(createQueryString(params, '/appointments'))
// const {
//   service_type,
//   start_date,
//   end_date,
//   size,
//   afterCursor,
//   client_name
// } = params

const getAppointmentsTransactionsList = async (params) =>
  axios.get(createQueryString(params, '/appointment_transaction'))

const updateTransaction = async (id, body) =>
  axios.put(`/appointment_transaction/${id}`, body)

const createTransaction = async (data) =>
  axios.post('/appointment_transaction', data)

const deleteTransaction = async (id) =>
  axios.delete(`/appointment_transaction/${id}`)

const getSessionStatistics = async (params) =>
  axios.get(createQueryString(params, '/appointments/session_statistics'))
// const { start_date, end_date, client_name } = params

const getClientsStatistics = async (params) =>
  axios.get(createQueryString(params, '/appointments/clients_statistics'))
// const { start_date, end_date } = params

const deleteAppointment = async (id) => axios.delete(`/appointments/${id}`)

const updateAppointment = async (id, body) =>
  axios.putJson(`/appointments/${id}`, body)
// body: {
//   client_name,service_provider_name, summary,service,duration,sessions_used,client_pay,location,start_at,end_at,notes
//   }

const createAppointment = async (body) => axios.postJson('/appointments', body)
// body: {
//   client_name,service_provider_name, summary,service,duration,sessions_used,client_pay,location,start_at,end_at,notes
//   }

// const { start_date, end_date, client_name, service_type, client_id } = params
const exportAppointmentsToCSV = async (params) =>
  await axios.get(createQueryString(params, '/appointments/export_csv'))

const getSessionUpdateRequest = async (id) =>
  axios.get(`appointment_transaction/session_update_request/${id}`)

const approveSessionUpdateRequest = async (id, body) =>
  axios.post(`appointment_transaction/session_update_request/${id}/approve`, body)

export {
  getAppointmentsList,
  getAppointmentsTransactionsList,
  updateTransaction,
  createTransaction,
  deleteTransaction,
  getSessionStatistics,
  getClientsStatistics,
  deleteAppointment,
  updateAppointment,
  createAppointment,
  exportAppointmentsToCSV,
  getSessionUpdateRequest,
  approveSessionUpdateRequest
}
